'use client';
import React from 'react';

import Skeleton from '@Components/design-system/skeleton';
import { SkeletonType } from '@Components/design-system/skeleton/types';
import { useInitialRule } from 'modules/appointment/hooks/directional-engine/rules';

const Page = () => {
  useInitialRule();
  return (
    <>
      <div className='flex flex-col gap-4 p-4 min-h-screen'>
        <Skeleton type={SkeletonType.CARD} repeat={1} />
        <Skeleton type={SkeletonType.SLOTS} repeat={5} />
      </div>
      <div className='fixed bottom-0 md:w-128 w-full'>
        <Skeleton type={SkeletonType.CTA} repeat={1} />
      </div>
    </>
  );
};

export default Page;
